// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination>li>a[data-v-14aef76a],.pagination>li>span[data-v-14aef76a]{height:2em;min-width:3em;padding:0}.pagination>li.pagination-text>span[data-v-14aef76a]{border:none;margin-top:1px;margin-right:1em}", ""]);
// Exports
module.exports = exports;
